import { render, staticRenderFns } from "./duoTileMobile.vue?vue&type=template&id=276b91c8&"
import script from "./duoTileMobile.vue?vue&type=script&lang=js&"
export * from "./duoTileMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports